'use client'

import { usePathname } from 'next/navigation'
import { type ReactNode } from 'react'

type Props = {
  children: ReactNode
  footer: ReactNode
  legacyClassName: string
  successPath: string
  standalonePathPrefixes?: string[]
}

export default function CheckoutFlowLayoutShell({
  children,
  footer,
  legacyClassName,
  successPath,
  standalonePathPrefixes = [],
}: Props) {
  const pathname = usePathname()

  if (
    pathname === successPath ||
    standalonePathPrefixes.some((prefix) => pathname.startsWith(prefix))
  )
    return children

  return (
    <>
      <div className={legacyClassName}>{children}</div>
      {footer}
    </>
  )
}
